module.exports = __webpack_public_path__ + "img/33.acce7b04.jpg";